import React, { useEffect, useState, useRef } from "react";
import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  MenuItem,
  Radio,
  InputLabel,
  Select,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  InputAdornment,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import FilterListIcon from "@mui/icons-material/FilterList";
import SendIcon from "@mui/icons-material/Send";
import BusinessIcon from "@mui/icons-material/Business";
import CircularProgress from '@mui/material/CircularProgress';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const AttendanceForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [time, setTime] = useState("");
const timeInputRef = useRef(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const dateInputRef = useRef(null);
  const navigate = useNavigate();
  const [employeeList, setEmployeeList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [attendance, setAttendance] = useState({});
  const [selectedRows, setSelectedRows] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [date, setDate] = useState("");
  const [selectAttendanceStatus, setSelectAttendanceStatus] = useState("1");
  const [searchQuery, setSearchQuery] = useState("");
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 25, 50, 100];
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(null);
const [isMaster, setIsMaster] = useState(false);

  // Info dialog state
  const [infoOpen, setInfoOpen] = useState(false);

useEffect(() => {
  if (selectedBranchId || !isMaster) {
    fetchEmployeeData();
  }
}, [selectedBranchId]);

  useEffect(() => {
  const today = new Date();
  const formattedDate = formatDate(today);
  setDate(formattedDate.display);
  dateInputRef.current = formattedDate.input;
  
  // Set current time
  const hours = String(today.getHours()).padStart(2, "0");
  const minutes = String(today.getMinutes()).padStart(2, "0");
  const currentTime = `${hours}:${minutes}`;
  setTime(currentTime);
  timeInputRef.current = currentTime;
}, []);

// Add time change handler
const handleTimeChange = (e) => {
  setTime(e.target.value);
};

  const token = sessionStorage.getItem('token');

  // AUTO-FILL: Fetch branches and auto-select first branch for master users
  const fetchBranches = async () => {
  try {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/Branch/GetBranch`;
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({}),
    });
    if (response.ok) {
      const data = await response.json();
      setBranches(data);
      // AUTO-FILL: automatically select the first branch for master users if none selected
      if (data && data.length > 0 && !selectedBranchId) {
        setSelectedBranchId(data[0].branchId);
      }
    } else {
      console.error("Failed to fetch branches");
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};

  const formatDate = (dateObj) => {
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return {
      display: `${day}/${month}/${year}`,
      input: `${year}-${month}-${day}`,
    };
  };


  useEffect(() => {
    const today = new Date();
    const formattedDate = formatDate(today);
    setDate(formattedDate.display);
    dateInputRef.current = formattedDate.input;
  }, []);


  // Fetch Departments
  const fetchDepartments = async () => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/Department/DepartmentName`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
      });
      if (!response.ok) throw new Error("Failed to fetch departments");
      const data = await response.json();
      setDepartments(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

 const fetchEmployeeData = async () => {
  setLoading(true);
  setError(null);
  const url = process.env.REACT_APP_BASE_URL;
  const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
  const apiUrl = `${url}/Employee/GetEmployee?Branch_Id=${branchId}`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
    });
    if (!response.ok) throw new Error("Failed to fetch employee data");
    const data = await response.json();
    const employeeData = Array.isArray(data) ? data : (Array.isArray(data.data) ? data.data : []);
    if (!employeeData || employeeData.length === 0) {
      setError("No employees found");
      setEmployeeList([]);
      setFilteredData([]);
    } else {
      setEmployeeList(employeeData);
      setFilteredData(employeeData);
      initializeAttendance(employeeData);
    }
  } catch (err) {
    setError(err.message);
    setEmployeeList([]);
    setFilteredData([]);
  } finally {
    setLoading(false);
  }
};

  // Fetch Employee Data
 useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);

  if (isMasterUser) {
    // AUTO-FILL: fetchBranches will auto-select first branch for master users
    fetchBranches();
  } else {
    // AUTO-FILL: non-master users get their branchId pre-filled from session storage
    const branchId = sessionStorage.getItem("branchId");
    setSelectedBranchId(branchId);
  }
  fetchDepartments();
}, []);



  const initializeAttendance = (employees) => {
    if (!employees || !Array.isArray(employees) || employees.length === 0) {
      setAttendance({});
      return;
    }
    
    setAttendance(
      employees.reduce((acc, emp) => {
        acc[emp.employeeCode] = attendance[emp.employeeCode] || "1";
        return acc;
      }, {})
    );
  };


  // Search and Filter Handler
  const handleSearch = (query, dept = selectedDepartment) => {
    let filtered = [...employeeList];
    
    if (query.trim()) {
      const lowerQuery = query.toLowerCase();
      filtered = filtered.filter((employee) => {
        const employeeCode = employee.employeeCode?.toLowerCase() || "";
        const employeeName = employee.employeeName?.toLowerCase() || "";
        const mobileNo = employee.mobileNo?.toLowerCase() || "";
        return (
          employeeCode.includes(lowerQuery) ||
          employeeName.includes(lowerQuery) ||
          mobileNo.includes(lowerQuery)
        );
      });
    }
    
    if (dept) {
      filtered = filtered.filter(
        (employee) => employee.departmentName === dept
      );
    }
    
    setFilteredData(filtered);
    setPage(1); // Reset to first page
  };


  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    handleSearch(query, selectedDepartment);
  };


  const handleDepartmentChange = (e) => {
    const dept = e.target.value;
    setSelectedDepartment(dept);
    handleSearch(searchQuery, dept);
  };


  const handleDateChange = (e) => {
    const dateValue = e.target.value;
    if (dateValue) {
      const [year, month, day] = dateValue.split("-");
      const formattedDate = `${day}/${month}/${year}`;
      setDate(formattedDate);
    }
  };


  const handleAttendanceChange = (employeeCode, value) => {
    setAttendance((prev) => ({ ...prev, [employeeCode]: value }));
  };


  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    const updatedSelectedRows = {};
    filteredData.forEach(employee => {
      updatedSelectedRows[employee.employeeID] = newSelectAll;
    });
    setSelectedRows(updatedSelectedRows);
  };


  const handleCheckboxChange = (employeeID) => {
    setSelectedRows((prev) => ({
      ...prev,
      [employeeID]: !prev[employeeID],
    }));
  };


const handleMarkAttendance = async () => {
  if (!date) {
    setSnackbarMessage("Please select a date.");
    setOpenSnackbar(true);
    setSnackbarSeverity("warning");
    return;
  }
  
  if (!time) {
    setSnackbarMessage("Please select a time.");
    setOpenSnackbar(true);
    setSnackbarSeverity("warning");
    return;
  }
  
  const attendanceDetails = employeeList
    .filter((employee) => selectedRows[employee.employeeID])
    .map((employee) => ({
      employeeID: employee.employeeID,
      status: parseInt(attendance[employee.employeeCode], 10),
    }));
    
  if (attendanceDetails.length === 0) {
    setSnackbarMessage("Please select at least one employee.");
    setOpenSnackbar(true);
    setSnackbarSeverity("warning");
    return;
  }
  
  setIsSubmitting(true); 

  // Convert date and time to DateTime object
  const [day, month, year] = date.split("/");
  const [hours, minutes] = time.split(":");
  const attendanceDateTime = new Date(
    parseInt(year),
    parseInt(month) - 1,
    parseInt(day),
    parseInt(hours),
    parseInt(minutes),
    0,
    0
  );
  
  const payload = {
    attendanceDate: attendanceDateTime.toISOString(),
    attendanceDetails,
  };
  
  const url = process.env.REACT_APP_BASE_URL;
  const apiUrl = `${url}/EmployeeAttendance/InsertEmployeeAttendance`;
  
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token
      },
      body: JSON.stringify(payload),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to mark attendance");
    }
    
    setSnackbarMessage('Attendance marked successfully!');
    setOpenSnackbar(true);
    setSnackbarSeverity("success");

    setSelectedRows({});
    if (Array.isArray(employeeList) && employeeList.length > 0) {
      setAttendance(
        employeeList.reduce((acc, emp) => {
          acc[emp.employeeCode] = "1";
          return acc;
        }, {})
      );
    }
    setSelectAll(false);
  } catch (err) {
    setSnackbarMessage("Error marking attendance: " + err.message);
    setOpenSnackbar(true);
    setSnackbarSeverity("error");
  }finally {
    setIsSubmitting(false); // stop loader regardless of outcome
  }
};


   const handleSelectAttendanceStatus = (status) => {
    setSelectAttendanceStatus(status);
    
    // Add safety check
    if (!Array.isArray(employeeList) || employeeList.length === 0) {
      return;
    }
    
    setAttendance((prev) => {
      const updatedAttendance = {};
      employeeList.forEach((employee) => {
        updatedAttendance[employee.employeeCode] = status;
      });
      return updatedAttendance;
    });
  };


  // Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  // ── Reusable AppBar JSX (title + info button + branch dropdown) ──
  const AppBarSection = (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#0B1F3D",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>

        {/* Left: Title + Info Button */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              letterSpacing: "0.5px",
              color: "#ffffff",
            }}
          >
            Employee Attendance Form
          </Typography>

          {/* ── Info Button ── */}
          <Tooltip title="About this form" arrow>
            <IconButton
              onClick={() => setInfoOpen(true)}
              size="small"
              sx={{
                color: "rgba(255,255,255,0.75)",
                border: "1.5px solid rgba(255,255,255,0.35)",
                borderRadius: "50%",
                width: 30,
                height: 30,
                ml: 0.5,
                transition: "all 0.2s ease",
                "&:hover": {
                  color: "#ffffff",
                  backgroundColor: "rgba(100,181,246,0.2)",
                  borderColor: "#64B5F6",
                  transform: "scale(1.1)",
                  boxShadow: "0 0 8px rgba(100,181,246,0.4)",
                },
              }}
            >
              <InfoOutlinedIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </Box>

        {/* Right: Branch Dropdown */}
        {isMaster && (
          <Box sx={{ position: "relative" }}>
            <FormControl size="small" sx={{ width: 220 }}>
              <InputLabel
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: "0.75rem",
                  fontWeight: 500,
                  letterSpacing: "0.6px",
                  textTransform: "uppercase",
                  top: "-2px",
                  "&.Mui-focused": { color: "#64B5F6" },
                  "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
                }}
              >
                Branch
              </InputLabel>
              <Select
                value={selectedBranchId || ""}
                onChange={(e) => setSelectedBranchId(e.target.value)}
                label="Branch"
                startAdornment={
                  <InputAdornment position="start">
                    <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
                  </InputAdornment>
                }
                sx={{
                  color: "#ffffff",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  letterSpacing: "0.3px",
                  backgroundColor: "rgba(255,255,255,0.07)",
                  backdropFilter: "blur(8px)",
                  borderRadius: "8px",
                  transition: "background-color 0.2s ease, box-shadow 0.2s ease",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(255,255,255,0.15)",
                    borderWidth: "1px",
                    transition: "border-color 0.2s ease",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.11)",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(255,255,255,0.35)",
                    },
                  },
                  "&.Mui-focused": {
                    backgroundColor: "rgba(255,255,255,0.1)",
                    boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#64B5F6",
                      borderWidth: "1.5px",
                    },
                  },
                  "& .MuiSelect-icon": {
                    color: "rgba(255,255,255,0.5)",
                    transition: "color 0.2s ease",
                  },
                  "&.Mui-focused .MuiSelect-icon": {
                    color: "#64B5F6",
                  },
                  "& .MuiSelect-select": {
                    py: 1.1,
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      mt: 0.5,
                      borderRadius: "10px",
                      border: "1px solid rgba(11,31,61,0.12)",
                      boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
                      overflow: "hidden",
                      "& .MuiList-root": { py: 0.5 },
                    },
                  },
                }}
              >
                {branches.map((branch) => (
                  <MenuItem
                    key={branch.branchId}
                    value={branch.branchId}
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 500,
                      color: "#0B1F3D",
                      px: 2,
                      py: 1.1,
                      mx: 0.5,
                      borderRadius: "6px",
                      transition: "background-color 0.15s ease",
                      "&:hover": {
                        backgroundColor: "rgba(11,31,61,0.07)",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(25,118,210,0.1)",
                        color: "#1565C0",
                        fontWeight: 600,
                        "&:hover": {
                          backgroundColor: "rgba(25,118,210,0.15)",
                        },
                      },
                    }}
                  >
                    {branch.branchName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );

  // ── Reusable Info Dialog ──
  const InfoDialog = (
    <Dialog
      open={infoOpen}
      onClose={() => setInfoOpen(false)}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "16px",
          boxShadow: "0 12px 40px rgba(11,31,61,0.2)",
          overflow: "hidden",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #0B1F3D 0%, #1565C0 100%)",
          color: "#ffffff",
          fontWeight: 700,
          fontSize: "1.2rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          py: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <InfoOutlinedIcon sx={{ fontSize: 22 }} />
          Employee Attendance Form — Guide
        </Box>
        <IconButton
          onClick={() => setInfoOpen(false)}
          size="small"
          sx={{ color: "rgba(255,255,255,0.8)", "&:hover": { color: "#fff" } }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2.5 }}>

        {/* Purpose */}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
          Use this form to record daily attendance for employees. Select a date and time,
          choose employees from the list, assign their attendance status, and submit.
          All fields marked as required must be filled before submission.
        </Typography>

        <Divider sx={{ mb: 2 }} />

        {/* Step-by-step */}
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
          How to Use — Step by Step
        </Typography>

        <List dense disablePadding>

          <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
              <CalendarTodayIcon sx={{ fontSize: 20, color: "#1976d2" }} />
            </ListItemIcon>
            <ListItemText
              primary={<Typography variant="body2" fontWeight={600}>Step 1 — Select Date</Typography>}
              secondary="Choose the attendance date using the Date picker. It defaults to today's date."
            />
          </ListItem>

          <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
              <AccessTimeIcon sx={{ fontSize: 20, color: "#1976d2" }} />
            </ListItemIcon>
            <ListItemText
              primary={<Typography variant="body2" fontWeight={600}>Step 2 — Select Time</Typography>}
              secondary="Set the attendance time. It defaults to the current time and can be changed manually."
            />
          </ListItem>

          <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
              <SearchIcon sx={{ fontSize: 20, color: "#1976d2" }} />
            </ListItemIcon>
            <ListItemText
              primary={<Typography variant="body2" fontWeight={600}>Step 3 — Search / Filter Employees</Typography>}
              secondary="Use the search bar to find employees by name, code, or mobile number. Use the Department dropdown to narrow down results."
            />
          </ListItem>

          <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
              <CheckBoxIcon sx={{ fontSize: 20, color: "#1976d2" }} />
            </ListItemIcon>
            <ListItemText
              primary={<Typography variant="body2" fontWeight={600}>Step 4 — Select Employees</Typography>}
              secondary="Tick the checkbox next to each employee you want to mark attendance for. Use the header checkbox to select or deselect all visible employees at once."
            />
          </ListItem>

          <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
              <FilterListIcon sx={{ fontSize: 20, color: "#1976d2" }} />
            </ListItemIcon>
            <ListItemText
              primary={<Typography variant="body2" fontWeight={600}>Step 5 — Set Attendance Status</Typography>}
              secondary="Use the bulk radio buttons above the table to set all selected employees to Present, Absent, or Leave at once. Or set each employee's status individually using the radio buttons in their row."
            />
          </ListItem>

          <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
            <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
              <SendIcon sx={{ fontSize: 20, color: "#1976d2" }} />
            </ListItemIcon>
            <ListItemText
              primary={<Typography variant="body2" fontWeight={600}>Step 6 — Submit</Typography>}
              secondary="Click 'Mark Attendance' to save the records. A success or error message will appear at the top of the screen."
            />
          </ListItem>

          {isMaster && (
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <LocationOnIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Branch Selector (Master Only)</Typography>}
                secondary="As a master user, select a branch from the top-right dropdown to load employees belonging to that branch."
              />
            </ListItem>
          )}

        </List>

        <Divider sx={{ my: 2 }} />

        {/* Status legend */}
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
          Attendance Status Options
        </Typography>

        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
          <Chip
            icon={<CheckCircleOutlineIcon sx={{ fontSize: 16, color: "green !important" }} />}
            label="Present"
            size="small"
            sx={{ fontWeight: 600, color: "green", border: "1px solid green", backgroundColor: "#f0fff4" }}
            variant="outlined"
          />
          <Chip
            icon={<CancelOutlinedIcon sx={{ fontSize: 16, color: "red !important" }} />}
            label="Absent"
            size="small"
            sx={{ fontWeight: 600, color: "red", border: "1px solid red", backgroundColor: "#fff5f5" }}
            variant="outlined"
          />
          <Chip
            icon={<EventBusyIcon sx={{ fontSize: 16, color: "orange !important" }} />}
            label="Leave"
            size="small"
            sx={{ fontWeight: 600, color: "darkorange", border: "1px solid orange", backgroundColor: "#fff8f0" }}
            variant="outlined"
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Important notes */}
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
          Important Notes
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
          {[
            "At least one employee must be selected before submitting.",
            "Both Date and Time are required fields for submission.",
            "The bulk status radio buttons apply only to currently selected (checked) employees.",
            "Changing the branch (master users) reloads the employee list automatically.",
            "After a successful submission, all checkboxes are cleared and statuses reset to Present.",
          ].map((note, i) => (
            <Typography key={i} component="li" variant="body2" color="text.secondary" sx={{ mb: 0.5, lineHeight: 1.6 }}>
              {note}
            </Typography>
          ))}
        </Box>

      </DialogContent>

      <DialogActions sx={{ backgroundColor: "#f5f5f5", px: 3, py: 2 }}>
        <Button
          onClick={() => setInfoOpen(false)}
          variant="contained"
          sx={{
            backgroundColor: "#0B1F3D",
            color: "#fff",
            borderRadius: "8px",
            fontWeight: 600,
            "&:hover": { backgroundColor: "#1565C0" },
          }}
        >
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );


  if (loading) {
    return (
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
          <Typography>Loading employee data...</Typography>
        </Box>
      </Container>
    );
  }


  if (error) {
    return (
      <Container maxWidth="lg">
        {AppBarSection}
        {InfoDialog}
        <Paper elevation={3} sx={{ padding: 4, marginTop: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '300px', gap: 2 }}>
            <Typography color="error" variant="h6">{error}</Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button variant="contained" onClick={() => window.location.reload()}>
                Retry
              </Button>
              <Button variant="outlined" onClick={() => navigate(-1)}>
                Go Back
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    );
  }


  if (!employeeList || employeeList.length === 0) {
    return (
      <Container maxWidth="lg">
        {AppBarSection}
        {InfoDialog}
        <Paper elevation={3} sx={{ padding: 4, marginTop: 1 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '300px', gap: 2 }}>
            <Typography variant="h6" align="center">No employees found. Please add employees first.</Typography>
            <Button variant="contained" onClick={() => navigate(-1)}>Go Back</Button>
          </Box>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      {AppBarSection}
      {InfoDialog}
     
      <Paper elevation={3} sx={{ padding: 3, width: "100%", margin: "auto", marginTop: 1 }}>
        {/* Date and Filters Section */}
        <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap", alignItems: "center" }}>
          <TextField
            id="date"
            label="Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            onChange={handleDateChange}
            defaultValue={dateInputRef.current}
            sx={{ width: "200px" }}
          />

          <TextField
  id="time"
  label="Time"
  type="time"
  InputLabelProps={{ shrink: true }}
  value={time}
  onChange={handleTimeChange}
  sx={{ width: "200px" }}
/>

          <TextField
            label="Search by Code, Name or Mobile"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{ flexGrow: 1, minWidth: "300px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            select
            label="Department"
            value={selectedDepartment}
            onChange={handleDepartmentChange}
            SelectProps={{ native: true }}
            sx={{ width: "200px" }}
            InputLabelProps={{ shrink: true }} 
          >
            <option value="" >All Departments</option>
            {departments.map((dept) => (
              <option key={dept.deptId} value={dept.departmentName}>
                {dept.departmentName}
              </option>
            ))}
          </TextField>
        </Box>

        {/* Bulk Action Section */}
        <Box
          sx={{
            mb: 2,
            p: 2,
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="h6" sx={{ color: "#1976d2", fontWeight: "bold" }}>
            Mark Attendance for Selected ({Object.values(selectedRows).filter(Boolean).length} selected)
          </Typography>

          <RadioGroup
            row
            value={selectAttendanceStatus}
            onChange={(e) => handleSelectAttendanceStatus(e.target.value)}
          >
            <FormControlLabel 
              value="1" 
              control={<Radio />} 
              label={<Typography fontWeight="bold" color="green">Present</Typography>} 
            />
            <FormControlLabel 
              value="0" 
              control={<Radio />} 
              label={<Typography fontWeight="bold" color="red">Absent</Typography>} 
            />
            <FormControlLabel 
              value="2" 
              control={<Radio />} 
              label={<Typography fontWeight="bold" color="orange">Leave</Typography>} 
            />
          </RadioGroup>
        </Box>

        {/* Table Section */}
        <TableContainer 
          component={Paper} 
          sx={{ 
            maxHeight: "500px", 
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
          }}
        >
          <Table
            stickyHeader
            sx={{
              minWidth: 650,
              '& .MuiTableCell-root': {
                borderRight: '1px solid #e0e0e0',
                fontSize: '0.95rem',
              },
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 'bold',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', width: "80px" }}>
                  S.No.
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', width: "100px" }}>
                  <Checkbox 
                    checked={selectAll} 
                    onChange={handleSelectAllChange}
                    indeterminate={
                      Object.values(selectedRows).filter(Boolean).length > 0 &&
                      Object.values(selectedRows).filter(Boolean).length < filteredData.length
                    }
                  />
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  Employee Name
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  Employee Code
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  Department
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  Mobile No
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', minWidth: "250px" }}>
                  Attendance Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length > 0 ? (
                paginatedData.map((employee, index) => (
                  <TableRow 
                    key={employee.employeeID} 
                    sx={{ 
                      '&:hover': { backgroundColor: '#f9f9f9' },
                      backgroundColor: selectedRows[employee.employeeID] ? '#e3f2fd' : 'inherit',
                    }}
                  >
                    <TableCell>
                      {(page - 1) * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        checked={!!selectedRows[employee.employeeID]}
                        onChange={() => handleCheckboxChange(employee.employeeID)}
                      />
                    </TableCell>
                    <TableCell sx={{ fontWeight: 500 }}>
                      {employee.employeeName}
                    </TableCell>
                    <TableCell>
                      {employee.employeeCode}
                    </TableCell>
                    <TableCell>
                      {employee.departmentName || "N/A"}
                    </TableCell>
                    <TableCell>
                      {employee.mobileNo || "N/A"}
                    </TableCell>
                    <TableCell>
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          value={attendance[employee.employeeCode] ?? "1"}
                          onChange={(e) => handleAttendanceChange(employee.employeeCode, e.target.value)}
                        >
                          <FormControlLabel 
                            value="1" 
                            control={<Radio size="small" />} 
                            label={<Typography fontSize="0.9rem" color="green">Present</Typography>}
                          />
                          <FormControlLabel 
                            value="0" 
                            control={<Radio size="small" />} 
                            label={<Typography fontSize="0.9rem" color="red">Absent</Typography>}
                          />
                          <FormControlLabel 
                            value="2" 
                            control={<Radio size="small" />} 
                            label={<Typography fontSize="0.9rem" color="orange">Leave</Typography>}
                          />
                        </RadioGroup>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography variant="body1" sx={{ py: 3 }}>
                      No employees found matching your criteria
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination Controls */}
        {filteredData.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
            <TextField
              select
              label="Rows per page"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              sx={{ width: 150 }}
              SelectProps={{ native: true }}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="body2">
                Page {page} of {Math.ceil(filteredData.length / rowsPerPage)} 
                &nbsp;({filteredData.length} total employees)
              </Typography>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page - 1)}
                disabled={page === 1}
                sx={{ minWidth: "80px" }}
              >
                Prev
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page + 1)}
                disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
                sx={{ minWidth: "80px" }}
              >
                Next
              </Button>
            </Box>
          </Box>
        )}

        {/* Action Buttons */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 3, gap: 2 }}>
          <Button 
            variant="outlined" 
            onClick={() => navigate(-1)}
            sx={{ minWidth: "120px" }}
          >
            Back to Home
          </Button>
          <Button
  variant="contained"
  onClick={handleMarkAttendance}
  disabled={isSubmitting}
  startIcon={isSubmitting ? <CircularProgress size={18} color="inherit" /> : null}
  sx={{ minWidth: "160px" }}
>
  {isSubmitting ? 'Marking...' : 'Mark Attendance'}
</Button>
        </Box>
      </Paper>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default AttendanceForm;